import React from "react";
import { Link } from "react-router-dom";
import styles from "./nomatch.module.css";

function Nomatch() {
  return (
    <div className={styles.notfoundContainer}>
      <div className={styles.notfound}>
        <div className={styles.notfound404}>
          <h1 className={styles.h1}>Oops!</h1>
          <h2 className={styles.h2}>404 - Страница не найдена</h2>
        </div>
        <Link to="/" className={styles.a}>
          Вернуться на главную страницу
        </Link>
      </div>
    </div>
  );
}

export { Nomatch };
